import axios from '../../axios.js'

/**
 * Inbound SG Peppol Accounts-Payable documents (the tenant is the BUYER).
 *
 * Read surface over the api-core `/peppol-ap-documents` endpoints, which expose
 * received Peppol Invoices / CreditNotes parsed from inbound C4 deliveries. This
 * is the SG Peppol (InvoiceNow) inbox — distinct from the MyInvois `/ap-documents`
 * module. From the detail view the tenant can send a BIS Invoice Response.
 * Reuses the AP_DOCUMENTS permission server-side.
 */
export default {
  namespaced: true,

  state: {
    documents: [],
    pagination: {
      currentPage: 1,
      totalPage: 1,
      totalItem: 0,
      limit: 25,
    },
  },

  mutations: {
    SET_DOCUMENTS(state, documents) {
      state.documents = Array.isArray(documents) ? documents : []
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination }
    },
  },

  getters: {
    documents: (state) => state.documents,
    pagination: (state) => state.pagination,
  },

  actions: {
    /**
     * Fetch a paginated, filterable list of inbound AP documents.
     * API: GET /peppol-ap-documents
     * @param {Object} payload - { page, limit, documentType, status, search }
     */
    fetchRecords({ commit }, payload = {}) {
      const { page = 1, limit = 25, ...filters } = payload
      const params = { page, limit, ...filters }

      return axios.get('/peppol-ap-documents', { params }).then((response) => {
        const body = response.data || {}
        commit('SET_DOCUMENTS', body.data || [])
        commit('SET_PAGINATION', {
          currentPage: body.page || page,
          totalPage: body.totalPages || 1,
          totalItem: typeof body.total === 'number' ? body.total : (body.data || []).length,
          limit: body.limit || limit,
        })
        return response
      })
    },

    /**
     * CSV export for ERP import (one row per line item, full header), read
     * from the original Peppol payload. Same filters as fetchRecords.
     * API: GET /peppol-ap-documents/export
     */
    exportCsv(context, params = {}) {
      return axios.get('/peppol-ap-documents/export', { params, responseType: 'blob' })
    },

    /**
     * Fetch a single inbound AP document by id.
     * API: GET /peppol-ap-documents/:id
     */
    fetchRecord(context, id) {
      return axios.get(`/peppol-ap-documents/${encodeURIComponent(id)}`).then((r) => r.data)
    },
  },
}
